module.exports = __webpack_public_path__ + "img/orig.d17e1406.png";